module.exports = __webpack_public_path__ + "static/media/ahumma.d0aa481e.png";